import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import {
  Button,
  Select,
  Input,
  Option,
  Table,
  TableColumn,
  Form,
  FormItem,
  Breadcrumb,
  BreadcrumbItem,
  Pagination,
  DatePicker,
  TabPane,
  Upload,
  Dialog,
  Tooltip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Menu,
  MenuItem,
  Submenu,
  Row,
  Col,
  Card,
  Message,
  MessageBox,
  Alert,
  Checkbox,
  CheckboxGroup,
  Switch,
  Tabs,
  Loading,
  Radio,
  RadioGroup,
  Tag,
  Autocomplete
  // ElTag,
} from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from "vue-i18n";
import { messages } from "./components/common/i18n";
// import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
import "./assets/css/icon.css";
import "./components/common/directives";
import "babel-polyfill";

import { Editable, EditableColumn } from "vue-element-extends";
import "vue-element-extends/lib/index.css";
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import exportCsv from "./utils/Csv/index";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

// NProgress.start()

Vue.use(Editable);
Vue.use(EditableColumn);

require("es6-promise").polyfill();

Vue.config.productionTip = false;
Vue.use(VueI18n);

Vue.use(Button);
Vue.use(Alert);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(TabPane);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Tooltip);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Tabs);
Vue.use(Loading);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Viewer)
Vue.use(Tag)
Vue.use(Autocomplete)

Vue.prototype.$ELEMENT = { size: "small" };
Vue.prototype.$axios = axios;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$exportCsv = exportCsv;

const i18n = new VueI18n({
  locale: "zh",
  messages,
});

// 允许ajax发送请求时附带cookie
axios.defaults.withCredentials = true;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {

  const role = localStorage.getItem("ms_username");
  const token = sessionStorage.getItem("token");
  if(token == "" || role == ""){
    next("/login");
  }
  //debugger
  if (!token && !role && to.path !== "/login") {
    next("/login");
  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    role === "admin" ? next() : next("/403");
  } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf("MSIE") > -1 && to.path === "/editor") {
      Vue.prototype.$alert(
        "vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看",
        "浏览器不兼容通知",
        {
          confirmButtonText: "确定",
        }
      );
    } else {
      next();
    }
  }
});
Vue.config.devtools = true
new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

//时间戳转化成格式时间
Vue.prototype.formatConversion = function (te){
	if(te == ''){
		return '';
	}else if(te.toString().length == 10){
		var time = new Date(te * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		var y = time.getFullYear();
		var m = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
		var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
		var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
		var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
		var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
		var timedate = y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
		return timedate;
	}else{
		var time = new Date(te);
		var y = time.getFullYear();
		var m = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
		var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
		var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
		var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
		var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
		var timedate = y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
		return timedate;
	}
}
